import { NgModule } from '@angular/core';
import { FullLocationPipe } from './full-location.pipe';
import { StreetPipe } from './street.pipe';

@NgModule({
   declarations: [FullLocationPipe, StreetPipe],
   exports: [FullLocationPipe, StreetPipe],
})
export class LocationModule {}
